/* ============================================================
   assets/wishlist.js — canonical wishlist module (§3.4)
   Single source of truth. Load once in theme.liquid:
     <script src="{{ 'wishlist.js' | asset_url }}" defer></script>
   Replaces the duplicated inline localStorage logic in
   featured-products / recently-viewed / main-wishlist /
   product-actions / theme.liquid.

   Public API (window.Tikolish.wishlist):
     .get()           -> array of product IDs (strings)
     .has(id)         -> boolean
     .add(id, handle) -> adds, fires update
     .remove(id)      -> removes, fires update
     .toggle(id, handle) -> returns true if now in list
     .count()         -> number
     .handles()       -> { id: handle }
   Fires document event 'tikolish:wishlist:updated' (detail: id array)
   on every change, plus syncs all [data-wishlist-icon] buttons.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'tikolish:wishlist';
  var HANDLES_KEY = 'tikolish:wishlist:handles';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('tikolish:wishlist:updated', { detail: arr }));
    syncIcons();
  }
  function readHandles() {
    try { return JSON.parse(localStorage.getItem(HANDLES_KEY) || '{}'); }
    catch (e) { return {}; }
  }
  function setHandle(id, handle) {
    if (!handle) return;
    var m = readHandles();
    m[String(id)] = handle;
    try { localStorage.setItem(HANDLES_KEY, JSON.stringify(m)); } catch (e) {}
  }

  var api = {
    get: function () { return read(); },
    has: function (id) { return read().indexOf(String(id)) !== -1; },
    count: function () { return read().length; },
    handles: function () { return readHandles(); },
    add: function (id, handle) {
      id = String(id);
      var arr = read();
      if (arr.indexOf(id) === -1) { arr.push(id); setHandle(id, handle); write(arr); }
    },
    remove: function (id) {
      id = String(id);
      var arr = read();
      var i = arr.indexOf(id);
      if (i !== -1) { arr.splice(i, 1); write(arr); }
    },
    toggle: function (id, handle) {
      id = String(id);
      var arr = read();
      var i = arr.indexOf(id);
      if (i === -1) { arr.push(id); setHandle(id, handle); write(arr); return true; }
      arr.splice(i, 1); write(arr); return false;
    }
  };

  // Reflect state on every [data-wishlist-toggle] button + its [data-wishlist-icon].
  function syncIcons() {
    var ids = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var pid = String(btn.getAttribute('data-product-id') || '');
      var active = ids.indexOf(pid) !== -1;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var icon = btn.querySelector('[data-wishlist-icon]');
      if (icon) {
        icon.setAttribute('fill', active ? 'currentColor' : 'none');
        btn.classList.toggle('is-wishlisted', active);
      }
    });
    // Update any wishlist counters
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = ids.length;
      el.classList.toggle('hidden', ids.length === 0);
    });
  }

  // Delegated click handling for all wishlist toggle buttons.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-product-id');
    var handle = btn.getAttribute('data-product-handle');
    if (!id) return;
    var nowIn = api.toggle(id, handle);
    if (window.tikolishToast) {
      window.tikolishToast(nowIn ? 'Added to wishlist' : 'Removed from wishlist');
    }
  });

  // Expose API + sync on load.
  window.Tikolish = window.Tikolish || {};
  window.Tikolish.wishlist = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncIcons);
  } else {
    syncIcons();
  }
})();
